import { useSelector } from 'react-redux'
import { Watchlist_WatchlistItem_Type } from '../../proto/generated/watchlist'
import { WatchlistItemData } from '../../reducer/watchList.reducer'
import { RootState } from '../../store'
import { getSecurityKey } from '../../util/security'

/** Re-renders only when this row's primary-match status toggles. */
export function useWatchlistItemIsMatched(data: WatchlistItemData): boolean {
    const expressionMode = data.item.type === Watchlist_WatchlistItem_Type.EXPRESSION

    return useSelector(
        (state: RootState) => {
            const { key } = state.homeStore.primarySecurity
            if (expressionMode) {
                const expressionSecurities =
                    state.homeStore.resolvedPrimarySecurity?.expressionSecurities || []
                const itemSecurities = data.item.securityExpression?.securities || []
                return (
                    expressionSecurities.length === itemSecurities.length &&
                    expressionSecurities
                        .map((s) => s.code)
                        .sort()
                        .every((code, i) => code === itemSecurities.map((s) => s.code).sort()[i])
                )
            }
            const securityKey = getSecurityKey(data.item.security?.exchange ?? 0, data.item.security?.code ?? '')
            return securityKey === key
        },
        (a, b) => a === b
    )
}
